<template>
  <div class="games">
    <div class="top-bg">
      <video src="@/assets/top-bg-video.mp4" autoplay loop muted ref="video" v-if="!$store.state.isMobile"></video>
      <span>GAMES</span>
    </div>
    <div class="games-wrapper">
      <div class="games">
        <div
        v-for="item in data.game"
        :key="item.app_id" 
        class="item"
        >
          <div class="top">
            <img :src="item.poster" class="bg">
            <img :src="item.icon" class="icon">
          </div>
          <div class="title">{{ item.name }}</div>
          <div class="desc">{{ item.introduction }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getIndexData } from '@/api/req'
export default {
  data() {
    return {
      data: {}
    }
  },
  activated() {
    if(!this.$store.state.isMobile) {
      this.$refs.video.play()
    }
  },
  mounted() {
    getIndexData().then(res => {
      this.data = res.data.data
    })
  },
}
</script>

<style lang="stylus" scoped>
.games
  padding-bottom 50px
  background #fff

.top-bg
  position relative
  height 438px
  background url('../assets/top-bg.png') no-repeat center top
  background-size cover
  font-size 64px
  font-weight 300
  color #ffffff
  text-align center
  line-height 438px

  @media screen and (max-width: 769px)
    display none

  span 
    position relative

  video 
    position absolute
    left 50%
    top 0
    transform translateX(-50%)

    @media screen and (max-width: 769px)
      display none

.games-wrapper
  padding-top 50px

  .games
    display flex
    flex-wrap wrap
    justify-content center
    max-width 1500px
    margin 0 auto

    .item
      width 440px
      height 460px
      background #F7F7F7
      border-radius 10px
      text-align center
      padding 10px
      box-sizing border-box
      margin 20px
      box-shadow 0px 3px 6px rgba(0, 0, 0, 0.16)

      @media screen and (max-width: 769px)
        width 290px
        height 320px

      .top
        position relative

        .bg
          width 400px
          height 250px
          border-radius 6px

          @media screen and (max-width: 769px)
            width 270px
            height 169px

        .icon
          position absolute
          left 50%
          bottom -45px
          transform translateX(-50%)
          width 100px
          height 100px
          border-radius 16px
          border 5px solid #fff
          box-sizing border-box

          @media screen and (max-width: 769px)
            bottom -28px
            transform translateX(-50%)
            width 60px
            height 60px
            border 3px solid #fff
            
      .title
        font-size 32px
        font-weight bold
        margin-top 66px

        @media screen and (max-width: 769px)
          font-size 24px
          font-weight bold
          margin-top 35px

      .desc
        font-size 14px
        margin-top 12px

        @media screen and (max-width: 769px)
          font-size 12px
          margin-top 10px
</style>